export const statusEnum = {
    0: {label:'待处理', type:'warning'},
    1: {label:'已处理', type:'success'},
    2: {label:'已关闭', type:'info'},
    3: {label:'已驳回', type:'danger'},
    4: {label:'处理中', type:''},
}
export const statusOptions= [
    {
      name: "待处理",
      code: 0,
    },
    {
      name: "已处理",
      code: 1,
    },
    {
      name: "已关闭",
      code: 2,
    },
    {
      name: "已驳回",
      code: 3,
    },
    {
      name: "处理中",
      code: 4,
    },
]

export const priorityEnum= {
    0: "一般",
    1: "重要",
    2: "严重",
}

export const approveStatusEnum = {
    'TODO': {label:'待审批', type:'warning'},
    'PASS': {label:'已通过', type:'success'},
    'FAIL': {label:'已拒绝', type:'danger'},
}
export const approveStatusOptions= [
    {
        value: "TODO",
        label: "待审批",
    },
    {
        value: "PASS",
        label: "已通过",
    },
    {
        value: "FAIL",
        label: "已拒绝",
    },
]

export const handleResultEnum = {
  'UNDER_REVIEW': {label:'审批中', type:''},
  'PASS': {label:'已通过', type:'success'},
  'NOT_PASS': {label:'未通过', type:'danger'},
  'OTHERS': {label:'无需审批', type:'info'},
}
export const handleResultOptions= [
  {
    value: "UNDER_REVIEW",
    label: "审批中",
  },
  {
    value: "PASS",
    label: "已通过",
  },  
  {
    value: "NOT_PASS",
    label: "未通过",
  },
  {
    value: "OTHERS",
    label: "无需审批",
  },
]

export const qaTestStatusEnum = {
  0: {label:'未质检', type:'warning'},
  1: {label:'已质检', type:'success'},
}
export const qaTestStatusOptions= [
  {
    value: 0,
    label: "未质检",
  },
  {
    value: 1,
    label: "已质检",
  },
]